import React, { Component, addCallback, addReducer } from "reactn"
import {
  Stack,
  Flex,
  Heading,
  SimpleGrid,
  Button,
  Text,
  VStack,
  Center,
  Box,
  useBreakpointValue,
  Container,
  HStack,
} from '@chakra-ui/react'
import CartItem from './cartItem'
import Circular from '../../icons/circular'
import ShoppingCartFooter from './shoppingCartFooter'

const ShoppingCart = ({ showSummary, globalState }) => {
  const { store, updateGlobal } = globalState
  const { cartProducts, cartTotal, shipping, packaging, totals, checkoutOpen } = store

  return (
    <Box id="shoppingCart">
      <Box id="shoppingCartItems" mt={['2','2','2','2']} ml={['0','0','0','5']} mr={['0','0','0','5']}>
        <VStack id="cartvstack">
          {cartProducts &&
            cartProducts.map((cartItem, i) => (
              <Box width={'100%'} key={`ci${i}`}>
                <CartItem product={cartItem} showSummary={showSummary} checkoutOpen={checkoutOpen} />
              </Box>
            ))}
        </VStack>
      </Box>
      {/* <Box > */}
        {/* <Promo></Promo>     */}
        {/* <ShoppingCartFooter /> */}
      {/* </Box> */}
      {/* </Flex> */}
    </Box>
  )
}

export default ShoppingCart